import { Form, Input, Modal, Radio, Switch, message } from 'antd';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import { ArrowUpRightFromSquareThin } from 'base/ui/components/Icons';
import CustomInputString from 'base/ui/components/Input/customInputString';
import useDebounce from 'hooks/useDebounce';
import usePartialState from 'hooks/usePartialState';
import { observer } from 'mobx-react';
import Criterial, { DetailCriterialIds } from 'pages/Components/CriterialSearch';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomerSegmentModel, ListCustomerCriteria, ListLazySegmentResponse, commonLazySegment } from 'services/Main/customerSegment_services';
import { customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { getPlantCode } from 'utils/localStorageHelper';
import { checkPermission } from 'utils/permissionHelper';
import TableListCount from './TableListCount';

type AddCustomerSegmentProps = {
  onMoveTab: (targetKey: string) => void;
  tabID: string;

  dataDetail?: CustomerSegmentModel;
};

function AddCustomerSegment(props: AddCustomerSegmentProps) {
  const { t } = useTranslation();
  const { onMoveTab, tabID } = props;
  const [formCreate] = Form.useForm();

  const [searchParams] = useSearchParams();
  // lấy id của tab (nếu như có id là tab xem chi tiết)
  const tabIdParam = searchParams.get('tabId');
  const changeTab = searchParams.get('changeTab');
  const tabIdCheck = tabIdParam?.includes('DETAIL') ? true : false


  const [loading, setLoading] = usePartialState({
    buttonSave: false,
    buttonCal: false
  })

  // Kiểm tra xem có lưu và cập nhật không
  const [isSaveContinue, setIsSaveContinue] = useState(false)

  // Kiểm tra xem có cho chỉnh sửa không
  const [componentDisabled, setComponentDisabled] = useState<boolean>(false);

  // hiển thị button view detail calculator
  const [viewDetail, setViewDetail] = useState(false)

  // list value trong mục tree select tiêu chí segmentation
  const [dataCriterial, setDataCriterial] = useState<DetailCriterialIds[]>([]);
  const [isShowModal, setIsShowModal] = usePartialState({
    listCountCustomer: false
  });


  const [dataSearch, setDataSearch] = useState<SearchModel>({
    companyCode: getPlantCode(),
    paging: {
      pageIndex: 1,
      pageSize: PAGE_SIZE_DEFAULT,
      orderBy: '',
      orderByDesc: '',
    },
  })

  const [loadingSegment, setloadingSegment] = useState(false)

  // danh sách khách hàng sau khi lọc tiêu chí
  const [dataListCustomerCriteria, setDataListCustomerCriteria] = useState<ListCustomerCriteria[]>([])

  // danh sách lazy segment
  const [listLazySegment, setListLazySegment] = useState<ListLazySegmentResponse[]>([])

  // HANDLE ONFINISH FORM ==================================================================================
  const handleFinishForm = async (fieldValues: any) => {
    setLoading({ buttonSave: true })
    setloadingSegment(true)
    const newCustomerSegment = {
      ...fieldValues,
      criterias: tabIdCheck ? undefined : dataCriterial,
      // field danh cho chỉnh sửa hoặc update
      customerSegmentId: tabIdCheck ? tabIdParam?.replace('DETAIL', '') : undefined,
      companyCode: getPlantCode(),
      isEditCS: tabIdCheck ? true : undefined,
    };

    if (tabIdCheck) {
      await customerSegmentPresenter.updateCustomerSegment(customerSegmentStore, newCustomerSegment);
    } else {
      await customerSegmentPresenter.createCustomerSegment(customerSegmentStore, newCustomerSegment);
    }

    if (customerSegmentStore.createCustomerSegment.isSuccess) {
      message.success(customerSegmentStore.createCustomerSegment.message);
      if (!isSaveContinue) {
        onMoveTab(tabID);
      }

      else {
        setIsSaveContinue(false)
      }
    } else {
      message.error(customerSegmentStore.createCustomerSegment.message);
    }
    setloadingSegment(false)
    setLoading({ buttonSave: false })
  }


  // =======================================================================================================

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = 'Bạn có chắc muốn rời khỏi trang? Dữ liệu chưa được lưu.';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // ------------------------ Hàm gọi tính số lượng khách hàng và lấy danh sách ----------------------------
  const [customerTotal, setCustomerTotal] = useState<undefined | number>(0)
  const handleCount = async () => {
    setloadingSegment(true)
    setLoading({ buttonCal: true })
    setViewDetail(true)
    setDataSearch({ ...dataSearch, criterias: dataCriterial })
    // lấy danh sách khách hàng lọc theo tiêu chí
    await getDataListCustomer({ ...dataSearch, companyCode: getPlantCode(), criterias: dataCriterial }, true)

    setLoading({ buttonCal: false })
    setloadingSegment(false)
  }

  const getDataListCustomer = async (dataSearch: SearchModel, isCal?: boolean) => {
    // set value initial cho biến data search
    const cloneData = { ...dataSearch }
    Object.assign(cloneData, {
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
      }
    })
    await customerSegmentPresenter.listCustomerByCriteria(customerSegmentStore, isCal ? cloneData : dataSearch)
    setDataListCustomerCriteria(customerSegmentStore.listCustomerCriteria.data)
    setCustomerTotal(customerSegmentStore.listCustomerCriteria.paging?.totalCount)
  }

  const getDataListLazySegment = async (key = '') => {
    await customerSegmentPresenter.getLazyCustomerSegment(customerSegmentStore, key ? key : undefined)
    setListLazySegment(customerSegmentStore.lazySegmentList.data)
  }

  const debounceSearchLazySegment = useDebounce(getDataListLazySegment, 500);

  // ---------------------- Mở danh sách khách hàng lọc theo tiêu chí ------------------------------------
  // -----------------------------------------------------------------------------------------------------
  const handleGetListCount = async () => {
    setIsShowModal({ listCountCustomer: true })
  }


  // =================================================== EDIT DETAIL ===================================================
  const handleGetDetail = async () => {
    setCustomerTotal(props.dataDetail?.customerNumber)
    formCreate.setFieldsValue({
      customerSegmentName: props.dataDetail?.customerSegmentName,
      description: props.dataDetail?.description,
      actived: props.dataDetail?.actived,
    })
  }



  // KIỂM TRA NẾU LÀ DETAIL THÌ CALL GĂN DETAIL VÀO CHO FORM ==========================================================
  useEffect(() => {
    if (!changeTab) {
      if (tabIdCheck) {
        handleGetDetail()
      } else {
        debounceSearchLazySegment('')
      }
    }
  }, [tabIdParam, changeTab])

  // test
  const [quickSearch, setQuickSearch] = useState<commonLazySegment[]>([])
  const [validSubmit, setValidSubmit] = usePartialState({
    isValidate: false,
    isSubmit: false
  })

  useEffect(() => {
    if (validSubmit.isSubmit) {
      formCreate.submit()
    }
  }, [validSubmit.isSubmit])


  return (
    <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm [&_textarea:forcus]:!shadow-none">

      {checkPermission('EDIT') && (
        <div className={`${tabIdCheck ? "!block" : '!hidden'} flex gap-2 mb-4`}>
          <div className='font-semibold text-default '>Chỉnh sửa: </div>
          <Switch
            checked={componentDisabled}
            onChange={(checked, e) => setComponentDisabled(checked)}
          />
        </div>
      )}
      <SearchForm
        form={formCreate}
        disabled={tabIdCheck ? !componentDisabled : false}
        onFinish={async (fieldValues) => {
          handleFinishForm(fieldValues)
        }}
        column="col-3"
        initialValues={{
          actived: true
        }}
      >
        {/* Quick search */}
        <SearchItem className={`${tabIdCheck ? 'hidden' : ''}`} label={'Tìm kiếm nhanh'}>
          <CustomSelect
            options={listLazySegment}
            fieldNames={{ label: "value", value: "key" }}
            allowClear
            showSearch
            onChange={(value, option) => {
              if (value && !Array.isArray(option)) {
                setQuickSearch(option.values)

              } else {
                setQuickSearch([])
              }

            }}
            onSearch={(values) => {
              values ? debounceSearchLazySegment(values) : debounceSearchLazySegment()
            }}
            filterOption={false}
            onClear={() => debounceSearchLazySegment()}
          />
        </SearchItem>
        {/* name customer segment (tên phân khúc) */}
        <SearchItem start name={'actived'} label={t('segment.trang-thai')} col2>
          <Radio.Group>
            <Radio value={true}>Sử dụng</Radio>
            <Radio value={false}>Ngưng sử dụng</Radio>
          </Radio.Group>
        </SearchItem>
        {/* name customer segment (tên phân khúc) */}
        <SearchItem start name={'customerSegmentName'} rules={[{ required: true, message: "Hãy nhập thông tin cho Tên phân khúc" }]} label={t('segment.ten-pk')}>
          <CustomInputString />
        </SearchItem>
        {/* Mô tả */}
        <SearchItem name={'description'} label={t('segment.mo-ta')} col2>
          <Input.TextArea rows={1} />
        </SearchItem>
      </SearchForm>


      {/* Lưu và Hủy */}
      <div className={`${tabIdCheck ? componentDisabled ? '' : '!hidden' : ''} col-span-3 mt-2 flex gap-default`}>
        <CustomButton htmlType="button" onClick={() => onMoveTab(tabID)}>
          {t('btn.cancel')}
        </CustomButton>

        <CustomButton
          className={`${tabIdCheck ? '!hidden' : '!block'}`}
          disabled={loading.buttonSave}
          onClick={() => {
            formCreate.validateFields().then((values) => {
              setValidSubmit({
                isValidate: true,
              })
            }).catch(() => {
              setValidSubmit({
                isValidate: false,
              })
            })
          }}
          type="primary"
        >
          {t('btn.save')}
        </CustomButton>
        <CustomButton
          className={`${tabIdCheck ? '!block' : '!hidden'}`}
          disabled={loading.buttonSave}
          onClick={() => {
            setIsSaveContinue(true)
            formCreate.submit();
          }}
          type="primary"
        >
          {t('btn.save-continue')}
        </CustomButton>
      </div>

      <Criterial
        isValidated={validSubmit.isValidate}
        validation={(value) => setValidSubmit({
          isValidate: false,
          isSubmit: value,
        })}
        quickSearch={quickSearch}
        dataDetail={props.dataDetail}
        onCriterialChange={(data) => {
          setDataCriterial(data);
        }}

        loadingSegment={loadingSegment}
      />


      {/* Calculator (COUNT) */}
      <div className='flex !items-center justify-between gap-8 mt-3'>
        <CustomButton
          onClick={handleCount}
          className='min-w-[125px] !outline-none'
          type='primary'
          disabled={loading.buttonCal}
          loading={loading.buttonCal}
        >
          Calculator
        </CustomButton>
        <div className={`text-[16px]`}>
          <div className={`grid grid-cols-2  ${customerTotal ? 'divide-x-2 divide-black' : ''}`}>
            <span className='px-2'><span className='font-semibold'>Tổng cộng: </span> {formatNumber(customerTotal)} khách hàng</span>
            {
              // customerTotal && !tabId ? (
              viewDetail ? (
                <div onClick={() => {
                  handleGetListCount()
                }} className='px-2 flex gap-2 items-center cursor-pointer'>
                  <span>Xem chi tiết</span>
                  <ArrowUpRightFromSquareThin />
                </div>
              ) : <></>
            }
          </div>
        </div>
        <div></div>
      </div>

      {/* Modal Danh sách */}
      <Modal
        style={{ top: 20 }}
        destroyOnClose
        title={<div className="text-base uppercase">Danh sách các trường thông tin hiển thị của khách hàng sau khi lọc tiêu chí</div>}
        className="min-w-[80%] w-full !p-0"
        open={isShowModal.listCountCustomer}
        onCancel={() => setIsShowModal({ listCountCustomer: false })}
        footer={null}
      >
        <TableListCount
          getDataListCustomer={getDataListCustomer}
          dataSearch={dataSearch}
          handleSearchList={setDataSearch}
          data={dataListCustomerCriteria} />
      </Modal>
    </div>
  );
}

export default observer(AddCustomerSegment);
